import { render, staticRenderFns } from "./ProjectDetailsSummary.vue?vue&type=template&id=a7cd067a"
import script from "./ProjectDetailsSummary.vue?vue&type=script&lang=ts"
export * from "./ProjectDetailsSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports